import { render, staticRenderFns } from "./InviteLink.vue?vue&type=template&id=b6c53f10&"
import script from "./InviteLink.vue?vue&type=script&lang=js&"
export * from "./InviteLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports